import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapAttributeHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Attribute;
    }
}

//# sourceMappingURL=WrapAttributeHelper.js.map
